<div class="page">
  <div class="container-fluid container-site py-4 py-lg-5">
    <div class="row mb-4">
      <div class="col">
        <div class="d-flex align-items-end">
          <div>
            <img
              src="/img/logo_liber_olive.webp"
              alt="Liber"
              height="30"
              class="me-3"
            />
          </div>

          <span class="d-block newsletter-header mt-auto lh-1">Newsletter</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="newsletter-box bg-card pb-3 pt-5 px-4">
          @if (submitted) {
            <div class="text-center pb-4">
              <h3>Hemos recibido tus datos</h3>
            </div>
          } @else {
            <form [formGroup]="form" (ngSubmit)="submit()" class="py-3">
              <p class="h5 mb-2">Suscríbase al boletín de Liber</p>

              <p class="lato-regular fw-light mb-4">
                Reciba nuestra newsletter semanal o trimestral con contenidos
                complementarios para profundizar en los temas que compartimos
                con la revista. Podrá encontrar libros, películas, música o
                documentales que enriquecerán la experiencia de la lectura.
              </p>

              <div class="d-flex flex-column flex-sm-row gap-2">
                <input
                  name="name"
                  formControlName="name"
                  type="text"
                  placeholder="Nombre"
                  required
                  class="form-control form-control-lg"
                />
                <input
                  name="lastname"
                  formControlName="lastname"
                  type="text"
                  placeholder="Apellido"
                  required
                  class="form-control form-control-lg"
                />
              </div>

              <div class="mt-2">
                <input
                  name="email"
                  formControlName="email"
                  type="email"
                  placeholder="Correo electrónico"
                  required
                  email
                  class="form-control form-control-lg"
                />
              </div>

              <div class="my-4">
                <h5>Elija lo que más le interese</h5>
              </div>

              <div class="d-flex flex-wrap newsletter-topics">
                <div class="w-100 w-sm-50">
                  <label class="lato-regular mb-0">
                    <input
                      type="checkbox"
                      class="me-1"
                      [ngModel]="receiveAll"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="onReceiveAllChange($event)"
                      name="receiveAll"
                    />
                    Recibir todas las recomendaciones
                  </label>
                </div>
                @for (topic of topics; track topic.slug) {
                  <div class="w-50 topic-item" [class.text-muted]="receiveAll">
                    <label class="mb-0">
                      <input
                        type="checkbox"
                        class="me-1"
                        [disabled]="receiveAll"
                        [checked]="receiveAll || selectedTopics.has(topic.name)"
                        (change)="
                          toggleTopic(topic.name, $any($event.target).checked)
                        "
                      />
                      {{ topic.name }}
                    </label>
                  </div>
                }
              </div>

              <div class="newsletter-checkbox my-3">
                <label class="small">
                  <input
                    name="legals"
                    formControlName="legals"
                    type="checkbox"
                    required
                    class="me-1"
                  />
                  Al suscribirme acepto los
                  <a
                    routerLink="/terminos-y-condiciones"
                    target="_blank"
                    rel="noopener"
                    >"Términos y Condiciones"</a
                  >
                  y el
                  <a
                    routerLink="/aviso-de-privacidad"
                    target="_blank"
                    rel="noopener"
                    >"Aviso de Privacidad"</a
                  >.
                </label>
              </div>

              @if (alertData()) {
                <div class="py-3 fade-in">
                  <app-alert [content]="alertData()"></app-alert>
                </div>
              }

              <div class="newsletter-checkbox">
                <button
                  type="submit"
                  class="btn btn-primary btn-contact w-100"
                  [disabled]="loading()"
                >
                  Suscribirme
                </button>
              </div>
            </form>
          }
        </div>
      </div>
      <div class="col-12 col-md-6">
        <img
          src="/img/liber-newsletter.webp"
          class="img-fluid"
          alt="Newsletter Liber"
        />
      </div>
    </div>
  </div>
</div>
